module.exports = __webpack_public_path__ + "images/emoji/mute.ed368ffb21583e7a1ca1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/mute.png
// module id = /7N2
// module chunks = 1